<section *ngIf="hasNonEmptyRows" [class.luxury]="listingCategory === ListingCategory.LUXURY" class="detail-wrapper">
  <div class="detail">
    <div class="detail-section-header" *ngIf="!hideTitle">
      <h4>{{ sectionTitle | translate }}</h4>
    </div>
    <ng-container *ngFor="let row of rows; trackBy: trackBy">
      <p class="detail-category" *ngIf="row.category">{{row.category}}</p>
      <div class="detail-row" *ngIf="!((!row.value && !row.default) || (row.title === 'board' || row.title === 'Board'))">
        <span class="detail-title">{{ row.title | translate }}: </span>
        <span class="detail-value">{{ row.value ? (row.value.startsWith('listingType.') ? (row.value | translate) : row.value) : row.default }}</span>
      </div>
    </ng-container>
    <div class="detail-row" *ngIf="mlsNum">
      <span class="detail-title">{{ 'details.mls-num' | translate }}: </span>
      <span class="detail-value">{{ mlsNum }}</span>
    </div>
  </div>
</section>
